import { RadioButtonTrueFalse } from "Components/Form/RadioButton";
import React from "react";
import { CarProductDetailsFormValues } from "./interfaces";

import { PaddedSurface as Surface } from "App/global-style";
import { ProductBackendName } from "Components/Features/CheckPrice/Products/productTypes";
import { RecentDamages } from "Components/Form/RecentDamages";
import { useTexts } from "Components/TextContext";
import { TextLanguage } from "Store/texts/interfaces";
import { getError } from "Utils/productUtils";
import { FormikProps } from "formik";
import { Bonus } from "./Bonus";

interface Props {
  formProps: FormikProps<CarProductDetailsFormValues>;
  texts: any;
  lang: TextLanguage;
  isCompanyChange: boolean;
}

export const FormElements = (props: Props): React.ReactElement => {
  const { formProps, texts, lang } = props;
  const { getText } = useTexts();

  return (
    <>
      <Bonus formProps={formProps} texts={texts} lang={lang} />
      <Surface>
        <RadioButtonTrueFalse
          name="mortgagee"
          id="mortgagee"
          label={getText("carform.label.morgagee")}
          error={getError("mortgagee", formProps)}
          direction="vertical"
        />
        <RecentDamages
          formProps={formProps}
          productName={ProductBackendName.CAR}
        />
      </Surface>
    </>
  );
};
